<mat-card *ngIf="init" class="mat-elevation-z0">
  <div class="d-flex">
    <div class="flexer">
      <div class="flexer">
        <div
          *ngIf="
            inputProduct.productPlacement?.actualPlacementDate != null &&
            inputProduct.productPlacement?.executionDate != null
          "
        >
          <div class="address-text space-bottom">
            {{
              inputProduct.type | productType : inputProduct.otherProductName
            }}

            <span class="product-number">#{{ index + 1 }}</span>
          </div>

          <div class="space-bottom">
            <span class="font-weight-bold">Plaatsing: </span>

            <span *ngIf="inputProduct.productPlacement?.executionDate == null">
              {{
                inputProduct.productPlacement.actualPlacementDate
                  | formatDate : '__/__' : 'dd/MM'
              }}
            </span>

            <span>
              {{
                inputProduct.productPlacement.executionDate
                  | formatDate : '__/__' : 'dd/MM'
              }}
            </span>
          </div>
        </div>

        <div
          class="space-bottom"
          *ngIf="inputProduct.productPlacement?.placers?.length > 0"
        >
          <span class="font-weight-bold">Installateur(s): </span>

          <span
            *ngFor="
              let person of inputProduct.productPlacement?.placers;
              let first = first
            "
          >
            {{ first ? '' : ', '
            }}{{ person.user?.firstName | personName : person.user?.lastName }}
          </span>
        </div>
      </div>

      <div *ngIf="inputWindowSticker != null">
        <ul>
          <li
            *ngIf="
              inputSubProject.projectPlacement?.placementFloor ||
              inputWindowSticker.productPlacement?.installerMinuteBudget ||
              inputWindowSticker.productPlacement?.heightEquipment
            "
          >
            <span *ngIf="inputSubProject?.projectPlacement?.placementFloor">
              {{ inputSubProject.projectPlacement.placementFloor }}
            </span>

            <span
              *ngIf="
                inputWindowSticker.productPlacement?.installerHourBudget ||
                inputWindowSticker.productPlacement?.installerMinuteBudget
              "
            >
              /
              {{
                inputWindowSticker.productPlacement.installerHourBudget
                  | formatSummaryTime
                    : inputWindowSticker.productPlacement.installerMinuteBudget
              }}
            </span>

            <span *ngIf="inputWindowSticker.productPlacement?.heightEquipment">
              / {{ inputWindowSticker.productPlacement?.heightEquipment.name }}
            </span>
          </li>

          <li>
            <span>{{ wetDisplay }} </span>

            <span>/ {{ insideDisplay }}</span>
          </li>

          <li *ngIf="obstructionsOrOldStickerDisplay?.length > 0">
            <span>{{ obstructionsOrOldStickerDisplay }} </span>
          </li>
        </ul>

        <div *ngIf="obstructionsDisplay?.length > 0">
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">Obstakels:</span>
            {{ obstructionsDisplay }}
          </span>
        </div>

        <div *ngIf="oldStickerDisplay?.length > 0">
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">Oude stickers:</span>
            {{ oldStickerDisplay }}
          </span>
        </div>

        <div
          *ngIf="inputWindowSticker.productPlacement?.installerInfo?.length > 0"
        >
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">Info installateur:</span>
            {{ inputWindowSticker.productPlacement.installerInfo }}
          </span>
        </div>
      </div>

      <div *ngIf="inputBoard != null">
        <ul>
          <li
            *ngIf="
              inputBoard.productPlacement?.installerHourBudget ||
              inputBoard.productPlacement?.installerMinuteBudget
            "
          >
            {{
              inputBoard.productPlacement.installerHourBudget
                | formatSummaryTime
                  : inputBoard.productPlacement.installerMinuteBudget
            }}
          </li>

          <li *ngIf="inputSubProject?.projectPlacement?.placementFloor">
            {{ inputSubProject.projectPlacement.placementFloor }}
          </li>

          <li *ngIf="inputBoard.productPlacement?.paintedPosts">
            Palen schilderen: Ja
            <div
              class="align-list-item"
              *ngIf="inputBoard.productPlacement.paintedPostsText?.length > 0"
            >
              <span class="preserve-line-break inline-flex">
                {{ inputBoard.productPlacement.paintedPostsText }}
              </span>
            </div>
          </li>

          <li
            *ngIf="
              inputBoard.productPlacement != null &&
              inputBoard.productPlacement.distanceToBottom != null
            "
          >
            {{
              'Afstand tot onderkant bord: ' +
                inputBoard.productPlacement.distanceToBottom.label
            }}
            <div
              class="align-list-item"
              *ngIf="
                inputBoard.productPlacement.distanceToBottom.ordinal === 0 &&
                inputBoard.productPlacement.distanceToBottomText?.length > 0
              "
            >
              {{ inputBoard.productPlacement.distanceToBottomText }}
            </div>
          </li>

          <li
            *ngIf="
              inputBoard.productPlacement != null &&
              inputBoard.productPlacement.obstaclesPresent != null
            "
          >
            {{
              'Obstakels aanwezig: ' +
                (inputBoard.productPlacement.obstaclesPresent ? 'Ja' : 'Nee')
            }}
            <div
              class="align-list-item"
              *ngIf="
                inputBoard.productPlacement.obstaclesPresent &&
                inputBoard.productPlacement.obstaclesInfo?.length > 0
              "
            >
              <span class="preserve-line-break inline-flex">
                {{ inputBoard.productPlacement.obstaclesInfo }}
              </span>
            </div>
          </li>
        </ul>

        <div *ngIf="inputBoard.productPlacement?.installerInfo?.length > 0">
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">Info installateur:</span>
            {{ inputBoard.productPlacement.installerInfo }}
          </span>
        </div>
      </div>

      <div *ngIf="inputOtherProduct != null">
        <ul>
          <li
            *ngIf="
              inputOtherProduct.productPlacement?.installerHourBudget ||
              inputOtherProduct.productPlacement?.installerMinuteBudget
            "
          >
            {{
              inputOtherProduct.productPlacement.installerHourBudget
                | formatSummaryTime
                  : inputOtherProduct.productPlacement.installerMinuteBudget
            }}
          </li>

          <li *ngIf="inputSubProject?.projectPlacement?.placementFloor">
            {{ inputSubProject.projectPlacement.placementFloor }}
          </li>

          <li
            *ngIf="
              inputOtherProduct.productPlacement != null &&
              inputOtherProduct.productPlacement.obstaclesPresent != null
            "
          >
            {{
              'Obstakels aanwezig: ' +
                (inputOtherProduct.productPlacement.obstaclesPresent
                  ? 'Ja'
                  : 'Nee')
            }}
            <div
              class="align-list-item"
              *ngIf="
                inputOtherProduct.productPlacement.obstaclesPresent &&
                inputOtherProduct.productPlacement.obstaclesInfo?.length > 0
              "
            >
              <span class="preserve-line-break inline-flex">
                {{ inputOtherProduct.productPlacement.obstaclesInfo }}
              </span>
            </div>
          </li>
        </ul>

        <div
          *ngIf="inputOtherProduct.productPlacement?.installerInfo?.length > 0"
        >
          <span class="preserve-line-break display-contents">
            <span class="strong inline-flex">Info installateur:</span>
            {{ inputOtherProduct.productPlacement.installerInfo }}
          </span>
        </div>
      </div>
    </div>

    <div class="flexer">
      <div class="d-flex images">
        <div
          *ngFor="
            let item of inputSubProject.projectPlacement
              ?.projectPlacementAssets;
            index as i
          "
        >
          <div
            *ngIf="
              item?.archived === false && item?.formSection === 'sitePhotos'
            "
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">
                  {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
                </div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>

        <div *ngFor="let item of inputProduct.productAssets; index as i">
          <div
            *ngIf="
              item?.archived === false && item?.formSection === 'execution'
            "
            class="loadedImg align-middle"
            matTooltip="{{ item?.asset?.name }}"
          >
            <div class="d-flex box click-link max-summary-width">
              <a
                download="{{ item.asset.name }}"
                href="/api/assets/{{ item.asset.uuid }}"
                style="margin-right: 7px"
                class="d-flex box"
              >
                <div class="filename">
                  {{ item?.asset?.name | shortenTextSplitOn : '.' : 10 }}
                </div>

                <a>
                  <mat-icon aria-hidden="false" aria-label="remove">
                    cloud_download
                  </mat-icon>
                </a>
              </a>
            </div>

            <a
              class="click-link"
              href="/api/assets/{{ item.asset.uuid }}"
              *ngIf="isImage(item.asset)"
              data-lightbox="product"
            >
              <img
                *ngIf="isImage(item.asset)"
                class="max-summary-width max-summary-height"
                src="/api/assets/{{ item.asset.uuid }}"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</mat-card>
